import { render, staticRenderFns } from "./ProcessPages.vue?vue&type=template&id=6cf3abc4&scoped=true&"
import script from "./ProcessPages.vue?vue&type=script&lang=js&"
export * from "./ProcessPages.vue?vue&type=script&lang=js&"
import style0 from "./ProcessPages.vue?vue&type=style&index=0&id=6cf3abc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf3abc4",
  null
  
)

export default component.exports